import "core-js/modules/es.function.name.js";
import { defineComponent as _defineComponent } from 'vue';
import { createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-61fd9909"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  "class": "consultant-card-wrapper"
};
var _hoisted_2 = {
  "class": "tw-container-xl tw-mx-auto tw-mb-10px tw-px-0"
};
var _hoisted_3 = ["id"];
var _hoisted_4 = {
  "class": "tw-flex tw-items-center tw-justify-center tw-gap-x-15px"
};
var _hoisted_5 = ["src", "alt", "onClick"];
var _hoisted_6 = ["href"];
var _hoisted_7 = ["innerHTML"];
var _hoisted_8 = {
  "class": "tw-flex tw-justify-center tw-gap-x-0.5"
};
import { ref, onMounted } from "vue";
import BaseAlert from "@vueEntry/UIKitComponents/BaseAlert.vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'CardSlider',
  props: {
    isUserLogged: {
      type: Boolean
    },
    consultants: {}
  },
  setup: function setup(__props) {
    var props = __props;
    var consultantDotList = ref(null);
    onMounted(function () {
      if (props.consultants) {
        consultantDotList.value[0].classList.add("active");
      }
    });
    var redirectOnConsultant = function redirectOnConsultant(consultant) {
      location.href = consultant.consultant_agency.url;
    };
    var activeRightCard = function activeRightCard(e) {
      var container = e === null || e === void 0 ? void 0 : e.target;
      var barPosition = container.scrollLeft;
      var firstDot = consultantDotList.value ? consultantDotList.value[0] : null;
      var secondDot = consultantDotList.value ? consultantDotList.value[1] : null;
      var thirdDot = consultantDotList.value ? consultantDotList.value[2] : null;
      var forthDot = consultantDotList.value ? consultantDotList.value[3] : null;
      var fifthDot = consultantDotList.value ? consultantDotList.value[4] : null;
      if (barPosition < 250) {
        firstDot === null || firstDot === void 0 ? void 0 : firstDot.classList.add("active");
        secondDot === null || secondDot === void 0 ? void 0 : secondDot.classList.remove("active");
        thirdDot === null || thirdDot === void 0 ? void 0 : thirdDot.classList.remove("active");
        forthDot === null || forthDot === void 0 ? void 0 : forthDot.classList.remove("active");
        fifthDot === null || fifthDot === void 0 ? void 0 : fifthDot.classList.remove("active");
      } else if (barPosition > 250 && barPosition < 650) {
        firstDot === null || firstDot === void 0 ? void 0 : firstDot.classList.remove("active");
        secondDot === null || secondDot === void 0 ? void 0 : secondDot.classList.add("active");
        thirdDot === null || thirdDot === void 0 ? void 0 : thirdDot.classList.remove("active");
        forthDot === null || forthDot === void 0 ? void 0 : forthDot.classList.remove("active");
        fifthDot === null || fifthDot === void 0 ? void 0 : fifthDot.classList.remove("active");
      } else if (barPosition > 650 && barPosition < 1050) {
        firstDot === null || firstDot === void 0 ? void 0 : firstDot.classList.remove("active");
        secondDot === null || secondDot === void 0 ? void 0 : secondDot.classList.remove("active");
        thirdDot === null || thirdDot === void 0 ? void 0 : thirdDot.classList.add("active");
        forthDot === null || forthDot === void 0 ? void 0 : forthDot.classList.remove("active");
        fifthDot === null || fifthDot === void 0 ? void 0 : fifthDot.classList.remove("active");
      } else if (barPosition > 1050 && barPosition < 1450) {
        firstDot === null || firstDot === void 0 ? void 0 : firstDot.classList.remove("active");
        secondDot === null || secondDot === void 0 ? void 0 : secondDot.classList.remove("active");
        thirdDot === null || thirdDot === void 0 ? void 0 : thirdDot.classList.remove("active");
        forthDot === null || forthDot === void 0 ? void 0 : forthDot.classList.add("active");
        fifthDot === null || fifthDot === void 0 ? void 0 : fifthDot.classList.remove("active");
      } else if (barPosition > 1450) {
        firstDot === null || firstDot === void 0 ? void 0 : firstDot.classList.remove("active");
        secondDot === null || secondDot === void 0 ? void 0 : secondDot.classList.remove("active");
        thirdDot === null || thirdDot === void 0 ? void 0 : thirdDot.classList.remove("active");
        forthDot === null || forthDot === void 0 ? void 0 : forthDot.classList.remove("active");
        fifthDot === null || fifthDot === void 0 ? void 0 : fifthDot.classList.add("active");
      }
    };
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock(_Fragment, null, [_createCommentVNode(" SLIDING BAR ELEMENT "), _createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", {
        id: "highlights",
        onScroll: activeRightCard,
        "class": "tw-flex tw-justify-between tw-no-scrollbar tw-mb-10px tw-gap-10px"
      }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.consultants, function (consultant, i) {
        return _openBlock(), _createElementBlock("div", {
          id: 'consultantSlidingCard' + i,
          ref_for: true,
          ref: 'consultantSlidingCard' + i,
          "class": "highlights-card"
        }, [_createVNode(BaseAlert, {
          "alrt-class": "tw-alert tw-alert-w-primary tw-w-[91vw] !tw-mb-0"
        }, {
          "default": _withCtx(function () {
            return [_createElementVNode("div", _hoisted_4, [_createElementVNode("img", {
              "class": "tw-object-contain tw-h-[32px] tw-cursor-pointer tw-mb-10px",
              src: "/rest/agency/getAgencyImageByAgencyID/".concat(consultant.consultant_agency.id, "/2"),
              alt: consultant.consultant_agency.name + ' - ' + 'photo' + '- 1',
              onClick: function onClick($event) {
                return redirectOnConsultant(consultant);
              }
            }, null, 8 /* PROPS */, _hoisted_5), _createElementVNode("a", {
              itemprop: "name",
              "class": "tw-text-left tw-text-14 tw-font-semibold",
              href: consultant.consultant_agency.url
            }, [_createElementVNode("span", {
              innerHTML: consultant.consultant_agency.name
            }, null, 8 /* PROPS */, _hoisted_7)], 8 /* PROPS */, _hoisted_6)])];
          }),
          _: 2 /* DYNAMIC */
        }, 1024 /* DYNAMIC_SLOTS */)], 8 /* PROPS */, _hoisted_3);
      }), 256 /* UNKEYED_FRAGMENT */))], 32 /* NEED_HYDRATION */), _createElementVNode("div", _hoisted_8, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.consultants, function (consultant, i) {
        return _openBlock(), _createElementBlock("div", {
          ref_for: true,
          ref_key: "consultantDotList",
          ref: consultantDotList,
          "class": "hDot tw-cursor-pointer"
        }, null, 512 /* NEED_PATCH */);
      }), 256 /* UNKEYED_FRAGMENT */))])])])], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */);
    };
  }
});